import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EventStatus } from '../../../../models/event.model';

@Component({
  selector: 'app-btn-event-status',
  standalone: true,
  templateUrl: './btn-event-status.component.html',
  styleUrls: ['./btn-event-status.component.css'],
})
export class BtnEventStatusComponent {
  @Input() status: EventStatus | undefined = EventStatus.unknown;
  @Input() isDisabled: boolean = false;

  @Output() onClick: EventEmitter<EventStatus> = new EventEmitter();

  eventStatus = EventStatus;

  constructor() {}
}
